/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-tag-spacing */
import React from 'react';
import PropTypes from 'prop-types';

const visuallyHidden = {
  position: 'absolute',
  height: 1,
  width: 1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap'
};

const Venn = ({ title, width, height, ...rest }) => (
  <>
    <svg
      aria-hidden="true"
      focusable="false"
      height={height}
      preserveAspectRatio="none"
      viewBox="0 0 24 24"
      width={width}
      {...rest}
    >
      <g clipPath="url(#clip0_493_16202)">
<path transform="scale(0.96 0.96)" fillRule="evenodd" clipRule="evenodd" d="M12.7015 0.79536C8.7555 0.652356 5.44447 3.84312 5.30613 7.92213C5.30008 8.10052 5.3002 8.27766 5.30629 8.45332C7.67739 7.50763 10.3111 7.84548 12.3662 9.24667C14.7647 7.6472 17.9301 7.48224 20.548 9.09554C24.2271 11.3629 25.4315 16.284 23.2381 20.0871C21.2663 23.5061 17.2203 24.8573 13.7497 23.4486C13.5531 23.3688 13.4563 23.1394 13.5335 22.9361C13.6107 22.7329 13.8327 22.6328 14.0293 22.7126C17.157 23.9821 20.8041 22.7633 22.5811 19.6822C24.5477 16.2722 23.4839 11.8652 20.2085 9.80724C19.7078 12.3746 18.0507 14.4912 15.8396 15.5761C15.9617 18.4303 14.6003 21.2603 12.0596 22.8249C8.37979 25.091 3.61954 23.8445 1.4273 20.0406C-0.543501 16.621 0.232069 12.2995 3.08201 9.81443C3.24347 9.67365 3.48477 9.69482 3.62097 9.86172C3.75717 10.0286 3.73669 10.2781 3.57522 10.4188C1.00682 12.6584 0.308409 16.5542 2.08447 19.6359C4.0544 23.054 8.32484 24.1813 11.6375 22.1644C9.68242 20.4996 8.67875 17.9805 8.83551 15.4606C6.19406 14.0565 4.4307 11.1662 4.54166 7.89443C4.6948 3.37898 8.36009 -0.153184 12.7283 0.00511993C16.6553 0.147434 19.8129 3.22347 20.3001 7.124C20.3271 7.34056 20.1792 7.53878 19.9697 7.56674C19.7602 7.5947 19.5685 7.44181 19.5414 7.22525C19.1014 3.70232 16.2482 0.923893 12.7015 0.79536ZM12.3052 21.7033C14.1065 20.2999 15.0914 18.1233 15.082 15.8991C14.1747 16.2298 13.1934 16.394 12.1737 16.357C11.2619 16.324 10.3916 16.1327 9.58649 15.8097C9.53674 18.0568 10.5039 20.2704 12.3052 21.7033ZM15.76 14.7335C17.6981 13.6853 19.1219 11.7427 19.5005 9.4172C17.375 8.4023 14.9567 8.58261 13.0292 9.75325C13.6975 10.3236 14.2841 11.0204 14.7532 11.8343C15.2828 12.7532 15.614 13.7373 15.76 14.7335ZM12.3614 10.2143C13.0391 10.7543 13.6315 11.433 14.096 12.2389C14.6127 13.1356 14.92 14.1011 15.0327 15.0746C14.1567 15.4257 13.1989 15.6029 12.2005 15.5668C11.296 15.534 10.4367 15.3289 9.65099 14.9831C9.77584 14.0549 10.0785 13.1367 10.5718 12.2813C11.049 11.4539 11.6609 10.7609 12.3614 10.2143ZM11.6983 9.74629C9.82474 8.5819 7.4746 8.36108 5.3793 9.27553C5.70734 11.5581 7.05002 13.5139 8.93202 14.6158C9.08927 13.6743 9.41318 12.7461 9.9148 11.8764C10.3978 11.0389 11.0053 10.3255 11.6983 9.74629Z" fill="#066869"/>
</g>

<clipPath id="clip0_493_16202">
<rect width="24" height="24" fill="white" transform="translate(0.333313)"/>
</clipPath>
    </svg>
    { title && <span style={visuallyHidden}>{title}</span>}
  </>
);

Venn.displayName = "Venn"

Venn.defaultProps = {
  height: 24,
  title: null,
  width: 24,
};

Venn.propTypes = {
  height: PropTypes.number,
  title: PropTypes.string,
  width: PropTypes.number,
};

export default Venn;
